import { jsx as _jsx } from "react/jsx-runtime";
import { HowDoesFaireSelectBrandsAnswer, HowToFindInsiderBrandsQuestion, HowToFindInsiderBrandsTwoThresholdsAnswer, ShippingCostsAnswer, CancellationAnswer, CoverageChangesAnswer, HowMuchDoesInsiderCostAnswerNoVat, useInsiderFAQStrings } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/__internal__/content";
import React, { useMemo } from "react";
export var useInsiderFAQContentsAUS = function() {
    var _useInsiderFAQStrings = useInsiderFAQStrings(), howMuchDoesInsiderCostQuestion = _useInsiderFAQStrings.howMuchDoesInsiderCostQuestion, coverageChangesQuestion = _useInsiderFAQStrings.coverageChangesQuestion, howDoesFaireSelectBrandsQuestion = _useInsiderFAQStrings.howDoesFaireSelectBrandsQuestion, shippingCostsQuestion = _useInsiderFAQStrings.shippingCostsQuestion, cancellationQuestion = _useInsiderFAQStrings.cancellationQuestion;
    var faq = useMemo(function() {
        return [
            {
                question: howDoesFaireSelectBrandsQuestion,
                answer: /*#__PURE__*/ _jsx(HowDoesFaireSelectBrandsAnswer, {})
            },
            {
                question: /*#__PURE__*/ _jsx(HowToFindInsiderBrandsQuestion, {}),
                answer: /*#__PURE__*/ _jsx(HowToFindInsiderBrandsTwoThresholdsAnswer, {})
            },
            {
                question: shippingCostsQuestion,
                answer: /*#__PURE__*/ _jsx(ShippingCostsAnswer, {})
            },
            {
                question: coverageChangesQuestion,
                answer: /*#__PURE__*/ _jsx(CoverageChangesAnswer, {})
            },
            {
                question: howMuchDoesInsiderCostQuestion,
                answer: /*#__PURE__*/ _jsx(HowMuchDoesInsiderCostAnswerNoVat, {})
            },
            {
                question: cancellationQuestion,
                answer: /*#__PURE__*/ _jsx(CancellationAnswer, {
                    sectionNumber: "9"
                })
            }
        ];
    }, [
        cancellationQuestion,
        coverageChangesQuestion,
        howDoesFaireSelectBrandsQuestion,
        howMuchDoesInsiderCostQuestion,
        shippingCostsQuestion
    ]);
    return faq;
};
